import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from './lib/auth/ProtectedRoute'
import { AppShell } from './components/layout/AppShell'
import { LoginPage } from './pages/LoginPage'
import { SetPasswordPage } from './pages/SetPasswordPage'
import { InvoicesPage } from './pages/InvoicesPage'
import { InvoiceDetailPage } from './pages/InvoiceDetailPage'
import { DiscrepanciesPage } from './pages/DiscrepanciesPage'
import { MonthlyClosePage } from './pages/MonthlyClosePage'
import { CostBreakdownPage } from './pages/CostBreakdownPage'
import { BankingPage } from './pages/BankingPage'
import { ProjectPnLPage } from './pages/ProjectPnLPage'
import { RecurringPage } from './pages/RecurringPage'
import { ReimbursementsPage } from './pages/ReimbursementsPage'
import { SettingsPage } from './pages/SettingsPage'
import { InboxPage } from './pages/InboxPage'
import { NotFoundPage } from './pages/NotFoundPage'

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/invoices" replace />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="/discrepancies" element={<DiscrepanciesPage />} />
        <Route path="/monthly-close" element={<MonthlyClosePage />} />
        <Route path="/cost-breakdown" element={<CostBreakdownPage />} />
        <Route path="/banking" element={<BankingPage />} />
        <Route path="/project-pnl" element={<ProjectPnLPage />} />
        <Route path="/recurring" element={<RecurringPage />} />
        <Route path="/reimbursements" element={<ReimbursementsPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/settings/*" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
